module.exports = __webpack_public_path__ + "static/media/OrderUpCubby.9abaae1e.png";